import { render } from "./ClassMetricsTableComponent.vue?vue&type=template&id=507b5791&scoped=true&ts=true"
import script from "./ClassMetricsTableComponent.vue?vue&type=script&lang=ts"
export * from "./ClassMetricsTableComponent.vue?vue&type=script&lang=ts"

import "./ClassMetricsTableComponent.vue?vue&type=style&index=0&id=507b5791&lang=postcss&scoped=true"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507b5791"]])

export default __exports__